import { ReactComponent as Logo } from "assets/images/onstreet.svg";
import ContentContainer from "components/ContentContainer";
import LogoContainer from "components/LogoContainer";
import MaxWidthContainer from "components/MaxWidthContainer";
import PopupsFullPageContainer from "components/PopupsFullPageContainer";
import SquareHighlightText from "components/SquareHighlightText";
import VideoOverlay from "components/VideoOverlay";
import useLocalizedRoutes from "hooks/useLocalizedRoutes";
import useYoutubePlayer from "hooks/useYoutubePlayer";
import { usePublicPagePopupsContext } from "iparque-components";
import React, { Suspense, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useTheme } from "styled-components";
import { sensingVideoIframeId } from "../IParqueModules/IParqueSensing/configs";
import { videoIds } from "./configs";
import {
  LoginButton,
  LoginButtonContainer,
  StyledHeading,
  StyledText,
  TextContainer,
  VideoButton,
} from "./styles";

const CityAnimation = React.lazy(() => import("./CityAnimation"));

const Head: React.FC = () => {
  const { t } = useTranslation();
  const { paddingTop, animationDuration } = usePublicPagePopupsContext();
  const theme = useTheme();
  const navigate = useNavigate();
  const sensingVideoPlayer = useYoutubePlayer(sensingVideoIframeId);
  const [videoVisible, setVideoVisible] = useState(false);
  const { getLanguageRoute } = useLocalizedRoutes();

  const onClickLogin = () => navigate(getLanguageRoute("login"));

  const showVideo = () => {
    sensingVideoPlayer?.pauseVideo();
    setVideoVisible(true);
  };

  const closeVideo = () => setVideoVisible(false);

  return (
    <PopupsFullPageContainer
      extraPaddingTop={paddingTop}
      extraPaddingTopAnimationDuration={animationDuration}
    >
      <header>
        <MaxWidthContainer>
          <LogoContainer>
            <Logo
              id="logo"
              role="img"
              title={
                t(
                  "10687"
                ) /* Logo da solução de gestão de estacionamento para concessionárias */
              }
              aria-labelledby={
                t(
                  "10687"
                ) /* Logo da solução de gestão de estacionamento para concessionárias */
              }
            />
          </LogoContainer>
        </MaxWidthContainer>
        <nav aria-label="Navegação principal">
          <LoginButtonContainer
            extraPaddingTop={paddingTop}
            extraPaddingTopAnimationDuration={animationDuration}
          >
            <LoginButton
              id="button"
              onClick={onClickLogin}
              extraPaddingTop={paddingTop}
              extraPaddingTopAnimationDuration={animationDuration}
            >
              {t("61") /* Entrar */}
            </LoginButton>
          </LoginButtonContainer>
        </nav>
      </header>
      <Suspense fallback={null}>
        <CityAnimation />
      </Suspense>
      <ContentContainer>
        <TextContainer id="text">
          <StyledHeading variant="h1" color="secondary">
            {t("9213") /* Monitorização em tempo real */}
          </StyledHeading>
          <StyledText>
            <p>
              {
                t(
                  "9214"
                ) /* Um dos grandes problemas das cidades são os estacionamentos. Ou melhor, a falta de gestão dos mesmos. */
              }
            </p>
            <p>
              {
                t(
                  "9215"
                ) /* O trânsito caótico, a desorganização, o ruído e até mesmo a poluição criam um ambiente nocivo, que pode ser mitigado com o iParque Onstreet. Com este sistema de monitorização e controlo de estacionamento, pode gerir as zonas, as ruas fiscalizadas, as equipas de fiscalização, atribuir rotas, obter estatísticas e relatórios. */
              }
            </p>
            <p>
              <b>
                {
                  t(
                    "9216"
                  ) /* Temos as ferramentas necessárias para ajudar na gestão do estacionamento da sua cidade, de forma eficiente e sustentável. */
                }
              </b>
            </p>
          </StyledText>
          <SquareHighlightText
            color={theme.colors.primary}
            text={t("9217") /* Gestão de Estacionamento para concessionárias */}
            className="mt-20"
          />
          <VideoButton
            onClick={showVideo}
            className="uppercase"
            title={
              t(
                "10688"
              ) /* As ferramentas necessárias para ajudar na gestão do estacionamento de uma cidade */
            }
          >
            {t("10132") /* Ver vídeo */}
          </VideoButton>
        </TextContainer>
      </ContentContainer>
      <VideoOverlay
        videoIds={videoIds}
        visible={videoVisible}
        onClose={closeVideo}
      />
    </PopupsFullPageContainer>
  );
};

export default Head;
